import { useQuery } from '@tanstack/react-query';
import SupportWidgetKeys from '../queryKeys';
import { getConversationDetailsAPI } from '../../../api/supportChat';
import { notifyError } from '../../../utils/notify';

const { getConversationDetails } = SupportWidgetKeys;

const fetchConversationDetails = async ({ sessionAddress }) => {
  const { data } = await getConversationDetailsAPI({ sessionAddress });
  return data;
};

const useGetConversationDetailsQuery = ({ sessionAddress }) =>
  useQuery(
    [getConversationDetails, sessionAddress],
    () => fetchConversationDetails({ sessionAddress }),
    {
      retry: false,
      enabled: !!sessionAddress,
      onError: e => {
        notifyError(e, false, 'Error fetching conversation details');
      },
    }
  );

export default useGetConversationDetailsQuery;
